import { TOGGLE_SHOW_FEEDBACK_FORM, SEND_FEEDBACK_SUCCESS, SEND_FEEDBACK_FAILED, RESET_FEEDBACK_FORM } from '../actions/feedbackForm';
const OPEN_LIGHTBOX = 'common/display/OPEN_LIGHTBOX';
const CLOSE_LIGHTBOX = 'common/display/CLOSE_LIGHTBOX';

const initialState = {
  lightbox: {},
  feedbackForm: { show: false, sent: false, sendingError: false }
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case RESET_FEEDBACK_FORM:
      return {
        ...state,
        feedbackForm: {
          ...state.feedbackForm,
          sent: false,
          sendingError: false,
        }
      }
    case SEND_FEEDBACK_FAILED:
      return {
        ...state,
        feedbackForm: {
          ...state.feedbackForm,
          sent: false,
          sendingError: true 
        }
      }
    case SEND_FEEDBACK_SUCCESS:
      return {
        ...state,
        feedbackForm: {
          ...state.feedbackForm,
          sent: true,
          sendingError: false
        }
      }
    case TOGGLE_SHOW_FEEDBACK_FORM:
      return {
        ...state,
        feedbackForm: {
          ...state.feedbackForm,
          show: action.toggle || false
        }
      }
    case OPEN_LIGHTBOX:
      return {
        ...state,
        lightbox: {
          ...state.lightbox,
          [action.lightbox]: {
            messageType: action.messageType,
            show: true
          }
        }
      };
    case CLOSE_LIGHTBOX:
      return {
        ...state,
        lightbox: {
          ...state.lightbox,
          [action.lightbox]: {
            show: false
          }
        }
      };
    default:
      return state;
  }
}


export function openLightbox(lightbox, messageType) {
  return {
    type: OPEN_LIGHTBOX,
    messageType,
    lightbox
  }
}

export function closeLightbox(lightbox) {
  return {
    type: CLOSE_LIGHTBOX,
    lightbox
  }
}



// WEBPACK FOOTER //
// ./modules/Common/reducers/display.js